import { UzEmptyState } from '@utazzo/ui';
import { Compass } from 'lucide-react';
import React from 'react';

import { PageShell } from '@/components/page-shell';

/**
 * Ticketing > Activities.
 *
 * Reserved. The website does not sell activities yet; when it does, their
 * bookings will land here beside flights and hotels. The page exists now so
 * the sidebar shows the shape of Ticketing as it will be, not as it is.
 */
export const TicketingActivitiesPage = (): React.JSX.Element => (
  <PageShell
    title="Activities"
    description="Activity bookings from the website will appear here once activities go on sale."
  >
    <div className="rounded-xl border border-dashed border-zinc-300 bg-white py-10">
      <UzEmptyState
        icon={<Compass className="h-8 w-8 text-zinc-400" aria-hidden />}
        title="Nothing here yet"
        description="Activities are not on sale on the website. Bookings will show up here the day they are, with the same detail, timeline and refund tools as flights and hotels."
      />
    </div>
  </PageShell>
);
